import React from 'react';
import Grid from '@mui/material/Grid2';
import { Close, Check } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { PasswordPolicy } from '../../slices/types';
import { PasswordValidationState } from './types';

const Item = styled(Stack)`
    justify-content: flex-start;
    align-items: center;
    padding: 2px;
    font-size: 12px;
`;

type Requirement = {
    description: string;
    show: boolean;
    isComplete: boolean;
};

interface Props extends PasswordValidationState {
    passwordPolicy: PasswordPolicy;
}

const Policy = ({
    hasMinLength,
    hasLetter,
    hasNumber,
    hasUppercase,
    hasSymbol,
    passwordsMatch,
    passwordPolicy,
}: Props) => {
    const requirements: Requirement[] = [
        {
            description: `At least ${passwordPolicy.minLength} characters`,
            show: true,
            isComplete: hasMinLength,
        },
        {
            description: '1 letter (a-z)',
            show: passwordPolicy.requiresLetter,
            isComplete: hasLetter,
        },
        {
            description: '1 number (0-9)',
            show: passwordPolicy.requiresNumber,
            isComplete: hasNumber,
        },
        {
            description: '1 uppercase letter (A-Z)',
            show: passwordPolicy.requiresUppercase,
            isComplete: hasUppercase,
        },
        {
            description: '1 symbol (!@#$%^&*()?")',
            show: passwordPolicy.requiresSymbol,
            isComplete: hasSymbol,
        },
        { description: 'Passwords Match', show: true, isComplete: passwordsMatch },
    ];

    const requirementsToShow = requirements.filter(item => item.show);

    return (
        <Grid container spacing={0} sx={{ marginTop: '20px', padding: '20px 50px' }}>
            {requirementsToShow.map((requirement, index) => (
                <Grid key={`requirement-${index}`} size={{ xs: 12, md: 6 }}>
                    <Item direction="row" spacing={1}>
                        {requirement.isComplete ? (
                            <Check color="success" fontSize="small" />
                        ) : (
                            <Close color="error" fontSize="small" />
                        )}
                        <div>{requirement.description}</div>
                    </Item>
                </Grid>
            ))}
        </Grid>
    );
};
export default Policy;
